// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from './api/axios'
import store from './store'
import ElementUI from 'element-ui'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueClipBoard from 'vue-clipboard2'
import 'element-ui/lib/theme-chalk/index.css'
import 'swiper/css/swiper.css'
import './styles/commonFont.scss'

// 20260920补充 过滤所有空白字符（包括空格、制表符、换行符等）
import noSpace from '@/directive/noSpace'

const wxLogin = require('./assets/js/wxLogin.js')
Vue.config.productionTip = false
Vue.prototype.$api = axios

Vue.use(ElementUI)
Vue.use(VueAwesomeSwiper)
Vue.use(VueClipBoard)
Vue.use(wxLogin)

// 20260920补充 过滤所有空白字符（包括空格、制表符、换行符等）
Vue.directive('noSpace', noSpace)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js